export default __webpack_public_path__ + "static/loader-black-e9d96ee7baa0dd1d94970bb624602bec.gif";